import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var productList = new Swiper(".section2 .swiper", {
    slidesPerView: 4,
    spaceBetween: 22,
    navigation: {
        nextEl: ".section2 .swiper-button-next",
        prevEl: ".section2 .swiper-button-prev",
    },
    pagination: {
        el: '.section2 .swiper-pagination',
        clickable: true,
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 24,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 24,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});